// extracted by mini-css-extract-plugin
export var container = "_ci-0";
export var infoIcon = "_ci-2";
export var titleRowCol = "_ci-1";